module.exports = __webpack_public_path__ + "img/signs9.81db6908.jpg";